import { useState } from 'react';
import DOMPurify from 'dompurify';

function decodeHtmlEntities(str) {
  const txt = document.createElement('textarea');
  txt.innerHTML = str;
  return txt.value;
}

function ReadMore({ htmlString }) {
  const [isReadMore, setIsReadMore] = useState(true);
  const cleanHtml = DOMPurify.sanitize(htmlString || '');

  const preview = decodeHtmlEntities(cleanHtml.replace(/<[^>]+>/g, ''));

  const toggleReadMore = () => setIsReadMore(!isReadMore);

  return (
    <div className="text">
      {isReadMore ? (
        <>
          {preview.slice(0, 250)}...
          <span
            onClick={toggleReadMore}
            className="read-or-hide"
            style={{ color: '#017EBD', cursor: 'pointer' }}
          >
            Read more
          </span>
        </>
      ) : (
        <>
          <div dangerouslySetInnerHTML={{ __html: cleanHtml }} />
          <span
            onClick={toggleReadMore}
            className="read-or-hide"
            style={{ color: '#017EBD', cursor: 'pointer' }}
          >
            Read less
          </span>
        </>
      )}
    </div>
  );
}

export default ReadMore;
